import { createTemplateApi } from "@org-avp/avp-avengers-template-service-api";
import { environment } from "@org-avp/avp-avengers-ui-shared-environment";
import { FetchBaseQueryArgs } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../utils/header.utils";

const defaultPageSize = 5_000;
const baseQueryArgs: FetchBaseQueryArgs = {
  baseUrl: environment.NX_TEMPLATE_SERVICE_BASE_URL,
  prepareHeaders,
};

export const templateApi = createTemplateApi({
  pageSize: defaultPageSize,
  baseQueryArgs,
});
